import React from 'react';
import kebabCase from 'lodash/kebabCase';
import cn from 'classnames';
import { IBaseElementProps } from 'tbk-components/src/components/BasicElement';
import Button, { ILink } from 'tbk-components/src/components/Button';
import Image, { IImage } from 'tbk-components/src/components/Image';

export interface ICareersInnerSidebarFormRegistrationCTABenefit {
	benefit?: string;
}

export interface ICareersInnerSidebarFormRegistrationCTAProps
	extends IBaseElementProps {
	registrationCTACalloutHeading?: string;
	/**
	 * Profile Callout Benefits
	 */
	registrationCTACalloutBenefits?: ICareersInnerSidebarFormRegistrationCTABenefit[];
	/**
	 * Profile Callout Button
	 */
	registrationCTACalloutButton?: ILink;
	/**
	 * Profile Callout Image
	 */
	registrationCTACalloutImage?: IImage;
}

/**
 * Calian Careers Inner Sidebar Form Registration CTA
 * @icon index-card
 * @block
 */
const CareersInnerSidebarFormRegistrationCTA: React.FC<ICareersInnerSidebarFormRegistrationCTAProps> =
	({
		className,
		classNames = [],
		registrationCTACalloutHeading,
		registrationCTACalloutBenefits,
		registrationCTACalloutButton,
		registrationCTACalloutImage,
	}) => {
		return (
			<div className="calian-careers-inner-sidebar-form-registration-cta calian-careers-inner-sidebar-success-message__content col-12 px-md-2 px-lg-8 h-100">
				<div className="d-flex flex-column justify-content-center align-items-center gap-5 gap-md-2 position-relative z-1">
					<div className="calian-careers-inner-sidebar-success-message__content--top">
						{registrationCTACalloutHeading && (
							<h3 className="text-white text-center ps-3 ls-0">
								{registrationCTACalloutHeading}
							</h3>
						)}
					</div>
					<div className="calian-careers-inner-sidebar-success-message__content--middle">
						{registrationCTACalloutBenefits && (
							<ul className="list-unstyled text-white px-6">
								{registrationCTACalloutBenefits.map(
									(benefit, index) => (
										<li
											key={index}
											className="d-flex flex-row justify-content-start align-items-start gap-3 mb-2 pb-1"
										>
											<i className="icon icon-check mt-1" />
											<p className="mb-0 text-white">
												{benefit.benefit}
											</p>
										</li>
									),
								)}
							</ul>
						)}
					</div>
					<div className="calian-careers-inner-sidebar-success-message__content--bottom mb-10 mb-lg-8">
						<div className="d-flex flex-row justify-content-center align-items-center">
							{registrationCTACalloutButton && (
								<Button
									{...registrationCTACalloutButton}
									className="btn btn-dark mt-2"
								/>
							)}
						</div>
					</div>
				</div>
				{registrationCTACalloutImage && (
					<Image
						{...registrationCTACalloutImage}
						className="img-fluid position-absolute bottom-0 end-0 z-0"
					/>
				)}
			</div>
		);
	};

export default CareersInnerSidebarFormRegistrationCTA;
